import { Hospital } from '@ianesthesie-kit/services';
import { HospitalService } from '@/modules/hospital';

export type BaseIsEnabledPredicate =
  | keyof Hospital
  | ((h?: Hospital) => boolean);
export type IsEnabledPredicate =
  | BaseIsEnabledPredicate
  | ['or' | 'and', ...IsEnabledPredicate[]];

export const pagePermissions = {
  earlyPostop: 'earlyPostopQuestionnaireModuleEnabled',
  chronicPain: 'dn4QuestionnaireModuleEnabled',
  customDocument: 'customDocumentModuleEnabled',
  premedication: 'premedicationModuleEnabled',
  billing: 'billingModuleEnabled',
  stripe: 'billingStripeEnabled',
  isNotUsap: (h: Hospital | undefined) =>
    !!h && !HospitalService.isUsapHospital(h)
} as const;

export const evaluate = (
  predicate: IsEnabledPredicate,
  hospital: Hospital | undefined
): boolean => {
  if (Array.isArray(predicate)) {
    const [operator, ...predicates] = predicate;
    if (operator === 'or') {
      return predicates.some((p) => evaluate(p, hospital));
    }
    if (operator === 'and') {
      return predicates.every((p) => evaluate(p, hospital));
    }
    throw new Error(`Unknown operator: ${operator}`);
  }
  if (typeof predicate === 'function') {
    return predicate(hospital);
  }

  return !!hospital?.[predicate];
};
